import TestimonialSwiper from "./TestimonialSwiper"

function Testimonial() {

  return (
    <section id="services" className="relative bg-white overflow-hidden py-20">
      <div className="flex flex-col">
        <div className="container">
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-3 mb-12">
              <div className="flex flex-row gap-4">
                <img src="/images/Icon/line.png" alt="Images" width={60} />
                <p className="flex justify-start items-center uppercase tracking-[2px] font-['Jost'] text-[10px] sm:text-[15px]">
                  Notre Équipe
                </p>
              </div>
            </div>
            <div className="px-3.5">
              <TestimonialSwiper/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;